import React, { useState } from "react";
import UserCurrentNewsFun from "./UserCurrentNewsFun";

const UserCurrentNewsList = () => {
  // Mock data for the news feed until the backend is hooked up
  const [mockNews, setMockNews] = useState([
    {
      id: 1,
      author: "Loading",
      category: "",
      timestamp: "ago",
      content: "",
      likes: 0,
      comments: 0,
    },
    {
      id: 2,
      author: "Loading ...",
      category: "",
      timestamp: "ago",
      content: "loading ...",
      likes: 0,
      comments: 0,
    },
    {
      id: 3,
      author: "Loading ...",
      category: "",
      timestamp: "ago",
      content: "loading...",
      likes: 0,
      comments: 0,
    },
  ]);

  return (
    <div style={{ marginTop: "20px" }}>
      <h2
        style={{
          borderBottom: "1px solid rgba(255,255,255,0.2)",
          paddingBottom: "10px",
          marginBottom: "20px",
          color: "white",
        }}
      >
        Ocancerz
      </h2>

      {/* Pass the data down to the mapping function */}
      <UserCurrentNewsFun newsData={mockNews} />
    </div>
  );
};

export default UserCurrentNewsList;
